export default {
  c1: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/%E7%B9%81%E4%BD%93%402x.png',
  c2: '積分明細',
  c3: '積分說明',
  c4: '啟用積分碼',
  c5: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/%E6%9D%A1%E6%AC%BE%E5%8F%8A%E7%BB%86%E5%88%99%402x.png',
  c6: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%402x.png',
  c7: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/%E6%88%91%E7%9A%84%E7%94%B5%E5%AD%90%E5%88%B8%402x.png',
  c8: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/mygarden%402x.png',
  c9: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E9%BB%9E%E6%88%91%402x.png',
  c10: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%8E%A9%E4%BB%BB%E5%8B%99%E8%B3%BA%E7%A9%8D%E5%88%86%402x.png',
  c11: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E6%B5%AE%E7%AA%97-%E7%B9%81%E9%AB%94%402x.png',
  c12: '熱門任務',
  c13: '賺取高額積分專區',
  c14: '查看更多',
  c15: '恭喜{Name}獲得',
  c16: '下次開盲盒',
  c17: '恭喜! 你獲得盲盒獎品',
  c18: '你可以在「積分明細」查看積分到帳情況',
  c19: '前往「積分明細」',
  c20: '你可以在「我的電子券」查看電子券到帳情況',
  c21: '前往「我的電子券」',
  c22: '你可以在「MyGarden」領取獎賞',
  c23: '前往「MyGarden」領取獎賞',
  c24: '多謝參與，明天再來',
  c25: '再開一個',
  c26: '知道了',
  c27: '你的手機或終端設備登入參加此活動的數量已超出限制',
  c28: '詳情請參閱',
  c29: '《條款及細則》',
  c30: '活動已結束',
  c31: '同一日不能同時獲取簽到積分和盲盒積分啊，聽日再來啦！',
  c32: '分享中獎喜悅給朋友啦!',
  c33: '分享喜悅',
  c34: '下次開盲盒',
  c35: 'MyLink幸運盲盒日日賞',
  c36: '每日獎賞可高達10,000 MyLink積分，更有機會得到MyGarden道具及電子優惠券! 馬上去開盲盒攞驚喜啦!',
  c37: '分享',
  c38: '我今日抽中左',
  c39: '! 你都快啲去開盲盒攞驚喜啦!',
  c40: '前往\n「積分明細」',
  c41: '前往\n「我的電子券」',
  c41_1: '前往\n「商城」使用',
  c41_2: '前往\n「遊戲樂園」',
  c41_3: '前往\n「保險頁」使用',
  c42: '前往\n「MyGarden」領取獎品',
  c43: '推廣生意的競賽牌照號碼：',
  c44: '條款及細則',
  c45: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/rule%203.png',
  c46: '參加本次活動前， 請先閱讀並同意以上《條款及細則》',
  c47: '不同意',
  c48: '同意並參加',
  c49: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E6%B5%AE%E7%AA%97-%E7%B9%81%E9%AB%94%402x.png',
  c50: 'MyLink幸運盲盒日日賞',
  c51: '每日獎賞可高達10,000 MyLink積分，更有機會得到MyGarden道具及電子優惠券! 馬上去開盲盒攞驚喜啦!',
  c52: '同一日不能同時獲取簽到積分和盲盒積分啊，聽日再來啦！',
  c53: '查看更多任务',
  c54: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/points%40tc.gif',
  c55: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/luckyCard/luckyCardTitle_tc.png',
  year: '年',
  month: '月',
  c56: '取消',
  c57: '選擇年月',
  c58: '完成',
  c59: '保存圖片',
  c60: '分享好友',
  c61: '每日箴言',
  c62: '哎呀,',
  c63: '沒開盲盒啊',
  c64: '圖片已保存到本地相冊',
  c65: '查看「每日箴言」',
  c66: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/luckyCard/luckyCardIcon_tc.png',
  c67: 'luckyCardImg_tc.png',
  c68: '遊戲專區',
  d1: '開盲盒提醒說明',
  d2: '開啟開盲盒提醒功能後，若本月開盲盒次數少於3天，系統將會於當月的8號、16號、24號發送開盲盒提醒通知，關閉功能則不提醒。',
  d3: '提醒搶券',
  d4: '宜',
  Rule: {
    c1: '「幸運盲盒」之條款及細則（「本條款及細則」）',
    c2: [
      '1.「幸運盲盒」（「活動」）由中國移動香港有限公司（「中移香港」）主辦。',
      '2.活動於香港時間2025年11月4日開始至2026年2月3日23:59結束（「活動期」），時間以中移香港的伺服器時間為準。'
    ],
    c3: '合資格人士',
    c4: [
      '3.參加者需要符合以下資格方為活動的合資格參加者（「合資格參加者」）:',
      '(a)可成功以有效香港電話號碼註冊並登入MyLink的人士，包括中移香港的現有儲值卡客戶、月費服務計劃客戶、家居寬頻客戶、企業客戶（包括副卡和成員卡客戶）及非中移香港用戶；及',
      '(b)非根據第23段被列入活動黑名單的人士。',
      '若未能符合上述資格，相關參加及/或得獎資格將會被取消。'
    ],
    c5: '活動詳情',
    c6: [
      '4.活動期內，合資格參加者可以以下方式參加活動：',
      '(a)從MyLink任務樂園直接點擊盲盒即可參加活動。',
      '(b)合資格參加者每天可享一次點擊盲盒機會，有機會得到MyLink積分 (「積分」)，積分數量為隨機發放、有機會得到MyGarden減碳值或功能卡、及有機會得到通訊、餐飲或零售券等電子券 （統稱為「獎品」）。',
      '(c)若合資格參加者當天沒有用完每天最多一次的點擊盲盒機會，未有使用或剩下的點擊盲盒機會將於當天23:59撤銷，並不能累積到下一天。',
      '(d)點擊盲盒的獎品為隨機發放，中移香港並不保證合資格參加者於活動期內可以獲得第4b段所列的獎品。',
      '5.每個終端設備（如手機、平板電腦）只限一位合資格參加者使用同五個香港流動電話號碼登記的MyLink賬號參加活動，如合資格參加者以同一個終端設備登入多於五個以上的MyLink賬號參加活動，中移香港有權取消相關MyLink賬號參加活動以及獲得積分的資格。'
    ],
    c7: 'MyLink積分使用及注意事項',
    c8: [
      '6.活動期內，合資格參加者如獲得積分，所獲得的積分會在3個工作天內自動存入其MyLink賬戶。積分餘額顯示在「個人頭像–我的積分」頁面。',
      '7.活動所獲得的積分有效期取決於積分被存入用戶的 MyLink 帳戶之時間。（「積分有效期」）。',
      '8.如活動領取的積分與任何其他積分領取活動的條款細則存有差異，一律以MyLink賬戶中所顯示的有效積分為準。',
      '9.合資格參加者應於積分有效期滿前使用積分作兌換獎賞或購買指定產品/服務，逾期作廢，並將不獲補發或延長有效期。合資格參加者兌換及使用積分，須閱讀並同意MyLink積分計劃的條款及細則（https://mylink.komect.com/mylink/#/integral/rules?lang=tc）。',
      '10.合資格參加者透過活動獲取積分後，不可退換或兌換現金，亦不能更換丶退款丶轉贈或轉讓他人，不同合資格參加者的積分亦不可合併使用。當合資格參加者撤銷其MyLink註冊賬戶時，其MyLink賬戶內的積分將會自動註銷及不獲補發，中移香港亦不會作出任何補償。'
    ],
    c9: 'MyGarden減碳值、功能卡使用及注意事項',
    c10: [
      '11.合資格參加者須前往MyLink 之MyGarden領取及使用活動所抽到的減碳值或功能卡待領取的減碳值有效期為合資格參加者每次領取減碳值的日期之翌日起計算的7日內到期，功能卡的有效期為合資格參加者獲取功能卡的日期之當日起計算的90日內到期，逾期無效。合資格參加者領取及使用減碳值或功能卡，須閱讀並同意MyGarden頁面內的MyGarden使用條款及細則 (詳情請瀏覽：https://cdn.mylinkapp.hk/via/atv/save-energy-forest/index.html#/rule?lang=tc&forceHideNavigationBar=true  並點擊「活動規則」查看) 。',
      '12.所有活動所獲得的MyGarden減碳值、功能卡不可退換或兌換現金，亦不能更換丶退款丶轉贈或轉讓他人，不同合資格參加者的MyGarden減碳值、功能卡亦不可合併使用。當合資格參加者撤銷其MyLink註冊賬戶時，其MyLink賬戶內的MyGarden減碳值、功能卡將會自動註銷及不獲補發，中移香港亦不會作出任何補償。'
    ],
    // c10_1:[
    //   'MyGame遊戲點券使用及注意事項',
    //   '13.合資格參加者如透過活動獲得MyGame遊戲點券，所獲得的MyGame遊戲點券會於領取當日起計7天內自動存入其MyLink帳號。',
    //   '14.參加者可在MyLink「遊戲樂園」頁面點擊右上角的「點券」，進入「我的點券」頁面查詢有關MyGame遊戲點券的詳情。',
    //   '15.合資格參加者領取及使用透過活動獲得的MyGame遊戲點券，須閱讀並同意MyGame「遊戲點券規則」頁面內的條款及細則 (https://hk.playinjoy.com/packages/center/temp/index.html?thirdPartyToken=<<cmcchkhsh_thirdparty_token_channel=bU9JU0HAZG>>&lang=<<cmcchkhsh_cmplang>>#/view/recharge-center/recharge-center-guide )。',
    //   '16.活動所獲得的MyGame遊戲點券均不可退換或兌換現金，亦不能更換丶退款丶轉贈或轉讓他人，不同合資格參加者的MyGame遊戲點券亦不可合併使用。當合資格參加者撤銷其MyLink註冊賬戶時，其MyLink賬戶內的MyGame遊戲點券將會自動註銷，中移香港亦不會作出任何補償。',
    // ],
    c11: '電子券使用及注意事項',
    c12: [
      '13.活動期內，合資格參加者如獲得電子券，所獲得的電子券會在3個工作天內自動存入其MyLink賬戶。',
      '14.合資格參加者兌換及使用電子券，須閱讀並同意該電子券的條款及細則，電子券的條款及細則可在「個人頭像–我的電子券」頁面查閱。',
      '15.所有活動所獲得的電子券均不可退換或兌換現金，亦不能更換丶退款丶轉贈或轉讓他人，不同合資格參加者的電子券亦不可合併使用。當合資格參加者撤銷其MyLink註冊賬戶時，其MyLink賬戶內的電子券將會自動註銷及不獲補發，中移香港亦不會作出任何補償。',
      '16.所有電子券在使用期限過後均屬無效，任何逾期或未使用之電子券將不能退款、補發或更改為其他產品或服務。'
    ],
    c13: '個人資料注意事項',
    c14: [
      '17.合資格參加者同意中移香港之一般個人資料收集聲明及私隱政策聲明所載之內容，並接受其約束。上述聲明分別載於 https://www.hk.chinamobile.com/tc/pics.html 及 https://www.hk.chinamobile.com/tc/privacy.html 。',
      '18.合資格參加者可能會被要求向中移香港提供個人識別資料。為讓參加者可以參加活動，該些資料是必要的。倘若參加者未能提供所需資料，參加者將不能獲得活動參加/獲得獎品的資格。',
      '19.合資格參加者有權根據《個人資料（私隱）條例》(第 486 章)的規定，要求查閱或更正參加者之個人資料。如有任何查閱或更正資料的要求，詳情請參閱中移香港的私隱政策聲明。',
      '20.合資格參加者如欲查閱個人資料及更正個人資料或詢問個人資料有關聲明，請致函：中國移動香港有限公司，地址：香港新界葵涌葵昌路 51 號九龍貿易中心 1 座 20 樓，收信人：資料保護主任；或致電中國移動香港拒收商業電子訊息登記 熱線 6226 4926 或客戶服務熱線 12580。'
    ],
    c15: '其他注意事項',
    c16: [
      '21.如發現合資格參加者以外掛程式或其他非正式途徑，如空號或假帳戶或其他影響公平性的方式參加活動， 中移香港將取消該參加者的參加活動資格而不作另行通知。',
      '22.如中移香港懷疑任何合資格參加者有（i）進行或與異常/可疑活動有關；或（ii）使用不當的方法或欺詐行為而使活動之任何部份運作中斷或受到干擾，或導致技術問題；或發現（iii）任何不誠實的行為、提供虛假、錯誤或不正確的資料；或（iv）任何違反本條款及細則或其他任何適用法律或法例條文或任何監管規定；或（v）用戶有任何非善意或惡意使用任何相關服務之情況；中移香港擁有酌情權及最終決定權在不作任何通知及毋須對任何人士負上任何責任的情況下，自行 決定暫停、取消其參加活動或獲得獎品的資格及日後推廣活動的資格，並對該用戶保留追究權利。',
      '23.如任何人士曾經在中移香港的MyLink及網上商店的活動、或任何使用MyLink及網上商店的過程中作出不誠實及欺詐行為、或任何非善意或非正常之使用、或曾經違反中移香港任何活動之條款及細則之行為，將自動被列入活動黑名單，喪失參與活動及獲得獎品的資格。',
      '24.所有是次活動所獲贈的獎品受到相關條款及細則所限。',
      '25.中移香港對任何第三方供應商在活動中所提供的獎品或相關商品、服務之品質、安全性及合法性，第三方供應商的商譽與可信性均無控制力及保證。如對以上禮品或相關商品、服務的質素或供應情況有任何查詢、申索或投訴，客戶應直接向有關供應商提出。中移香港對此不承擔任何責任。',
      '26.在法律容許之最大限度，中移香港不會對第三方在活動中供應之獎品的任何功能或内容、及使用獎品可能或實質所造成或引致的任何後果、費用、支出、損失或損害負上任何責任。',
      '27.中移香港並不會對任何第三方供應商在活動中所提供的獎品或相關商品、服務之任何相關資料、内容及其功能，包括但不限於特定目的之適用性、可用性、質量、性質、準確性和實用性、或當中可能包含之知識產權之正當性作出任何陳述、保證或承擔任何責任。',
      '28.如因電力或網絡故障、或其他中移香港不能控制的情況下任何服務失效、中斷、延誤或暫時中止所引致之損失及損害（不論直接或間接），例如因任何技術故障、困難或錯誤、網絡故障、中斷或擠塞、手機程式故障、任何第三方引致之原因、軟體的不相容性問題或其他任何原因（包括但不限於任何終端設備或互聯網網絡問題）而產生或引致任何遲延、遺失、錯誤或無法辨識的回應等情況、或未能參加活動或獲得獎品，中移香港概不負責及不會作出任何補發或補償。',
      '29.參加者參加活動及/或領取獎品純屬自願性質及需自行承擔參加活動及/或領取獎品之任何風險及全部責任。任何合資格參加者因參加活動及/或領取獎品而引致之任何損失、傷害、費用、索賠、訴訟（包括但不限於直接、間接及後果性損失），中移香港概不負上任何法律責任或作出賠償。',
      '30.在法律容許之最大限度下，凡由於中移香港無法合理控制或並非其過失或疏忽所致的原因，包括天文台懸掛黑色暴雨、八號烈風或暴風信號或更高熱帶氣旋警告信號、或香港政府公布的「極端情況」或自然災害；或由香港政府或任何其他適用的國家法律機關所實施的限制，以致延遲或未能履行本條款及細則第2、4、6、7、9、11、13、及/或28條而造成任何損失或損害，中移香港均無須負責。',
      '31.本條款及細則及一切與本條款及細則相關的事項均應受香港法律專屬管轄及以其作解釋及執行。參加者同意，如有任何分歧、爭議、請求、訴訟或索賠等，將不可撤回及無條件地服從香港法院的專屬管轄權。 ',
      '32.本條款及細則中的每一條條款應有獨立的執行力，其有效性不受其他條款之無效性影響。',
      '33.如任何參加者有任何違反法律、本條款及細則或可能損害第三方權利的行為或不作為，該參加者同意並契諾向中移香港為其行為或不作為引致或相關的任何糾紛及索賠作出全面彌償以及使中移香港免受損害。',
      '34.除合資格參加者和中移香港外，任何人均不享有香港法例《合約(第三者權利)條例》(第623章)下的任何權利，以執行或享有本條款及細則任何條文的利益或權利。',
      '35.活動不設上訴機制。如有任何爭議，中移香港保留最終決定權。任何爭議將以中移香港之系統記錄作為確據。',
      '36.本條款及細則的中、英文版如有任何歧義，概以中文版為準。',
      '37.推廣生意的競賽牌照號碼：',
      '38.活動完結聲明會在2026年2月6日於星島日報及英文虎報刊登。'
    ]
  },
  d5: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon1_tc.png',
  d6: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon2_tc.png',
  d7: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon3_tc.png',
  d8: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon4_tc.png',
  d8_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon5_tc.png',
  d9: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/jinbi.png',
  d10: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/ticket_over_tc.png',
  d11: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/tikect_normal.png',
  d12: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/top_title-img.png',
  d13: '日曆規則',
  d14: '本月積分簽到累計',
  d15: '天',
  d16: '每月積分簽到累計滿14天可獲',
  d17: '積分 (每月限領一次)',
  d18: '每日黃曆',
  d19: '積分',
  d20: '卡券領取',
  d21: '已領取卡券',
  d22: '卡券搶晒了!',
  d23: '是日無卡券 ',
  d24: '積分簽到',
  d25: '已簽到領分',
  d26: '你已簽到領積分了',
  d27: '本月累計簽到已滿14天, 獲得100積分',
  d28: '(每月限領一次)',
  d29: '簽到成功',
  d30: '前往「積分攻略」',
  d31: '可以搶券啦, 手快有手慢無',
  d32: '黎遲一步',
  d33: '搶晒了!',
  d34: '搶券成功',
  d35: '前往「我的電子券」>',
  d36: '前往「積分明細」>',
  d37: '你已領券了',
  d38: '',
  d39: '可搶券, 手快有手慢無',
  d40: '黎遲一步, 搶晒了!',
  d41: '',
  d42: '可搶券, 記得黎啊',
  d43: '你的手機或終端設備登入參加此活動的數量已超出限制',
  d44: '詳情請參閱',
  d45: '《條款及細則》',
  d46: '知道了',
  d47: '剩餘',
  d48: '份',
  d49: '提醒搶券說明',
  d50: '開啟搶券提醒功能後，逢週一系統會發送提醒通知，關閉則不通知。',
  d51: '獎賞記錄',
  d52: '日曆獎賞',
  d53: '年',
  d54: '月',
  d55: '僅展示近6個月的記錄',
  d56: '盲盒獎賞',
  d57: '完成',
  d58: '取消',
  d59: '選擇年月',
  d60: '日',
  d61: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox12/smallClick_tc_new.webp',
  d62: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/button_bottom_tc.png',
  d63: '每日簽到賞你積分, 仲不定時發放電子優惠券, 先到先得! 快啲睇下有咩優惠券可以搶啦!',
  d64: 'MyLink獎賞日曆',
  d65: 'MyLink幸運盲盒',
  d66: '多謝參與',
  d67: '網絡異常，請重試',
  d68: '搶券成功',
  d69: '無記錄',
  d70: '週日',
  d71: '週一',
  d72: '週二',
  d73: '週三',
  d74: '週四',
  d75: '週五',
  d76: '週六',
  d77: '天',
  d78: '搶券反應熱烈, 幾分鐘後再試吧',
  d79: '拎多啲優惠券',
  d79_1: '會員日日拎著數',
  d80: '去商城花積分',
  d81: '去使用',
  d81_1: '去參加',
  d82: '今日仲有積分未領取喔',
  d83: '立即簽到領積分',
  ruleDate: {
    c1: '「獎賞日曆」之條款及細則（「本條款及細則」）',
    c1_1: '版本更新日期: 2026年3月12日',
    c2: [
      '1.「獎賞日曆」（「活動」）由中國移動香港有限公司（「中移香港」）主辦。',
      '2.活動於香港時間2024年2月4日開始至2026年6月30日23:59結束（「活動期」），時間以中移香港的伺服器時間為準。'
    ],
    c3: '合資格人士',
    c4: [
      '3.參加者需要符合以下資格方為活動的合資格參加者（「合資格參加者」）：',
      '(a)參加活動當日已年滿18歲或以上的人士；',
      '(b)可成功註冊並登入MyLink的人士，包括中移香港的現有儲值卡客戶、月費服務計畫客戶、家居寬頻客戶、企業客戶（包括副卡和成員卡客戶）及非中移香港用戶；及；',
      '(c)非根據第24段被列入活動黑名單的人士。',
      '若未能符合上述資格，相關參加活動及/或獲得MyLink 積分、電子券的資格將會被取消。'
    ],
    c5: '活動詳情',
    c6: [
      '4.活動期內，合資格參加者可以以下方式參加活動：',
      '(a)「積分簽到」活動：',
      'I.合資格參加者每個自然天在MyLink任務樂園頁面點擊「積分簽到」按鈕或於MyLink「極簡版」之「每日積分簽到活動」點擊「立即簽到」按鈕，即可簽到並獲取2 MyLink積分一次，若該用戶已付費辦理「Link著數會員卡」或「著數會員（灣區版）」、且該會員卡仍在生效當中（「會員卡客戶」），可額外獲得3積分。而當每個自然月內累計簽到滿14天，該第14天的簽到共可獲得100 MyLink積分（「滿14天100 MyLink積分」）。為免存疑，合資格參加者於獲得滿14天100 MyLink積分當天並不會獲得每日簽到的2 MyLink 積分，但會員卡客戶的額外3積分則不受影響。',
      'II.合資格參加者每日最多可簽到一次。除每個自然月內累計簽到的第14日外，合資格參加者簽到最多可獲得2 MyLink積分一次，會員卡客戶簽到亦最多可獲得相關額外3 MyLink積分一次。',
      'III.而滿14天100 MyLink積分每個自然月最多可領取一次。',
      'IV.為免存疑，合資格參加者已成功累計簽到滿14天並獲得滿14天100 MyLink積分後，如客戶在該自然月剩餘日子每日簽到仍可獲得最多2 MyLink積分，會員卡客戶簽到則同時可繼續獲得相關額外3 MyLink積分。',
      'V.累計簽到的次數於每個自然月最後一日下午23:59分清零並重新計算。',
      'VI.合資格參加者參與「積分簽到」活動並領取積分，該合資格參加者則不可同一天同時參與MyLink「極簡版」之「每日積分簽到活動」領取積分，反之亦然。合資格參加者於「積分簽到」活動及「極簡版」之「每日積分簽到活動」所累積的簽到次數將一併計算。同時，參加者每月從「積分簽到」活動及MyLink「極簡版」之「每日積分簽到活動」共可領取滿14天100 MyLink積分最多一次。',
      'VII.即日起至2026年6月30日期間, 合資格參加者每天於獎賞日曆完成積分簽到後,出現最多一次「睇廣告賺5積分!」的按鈕。若因系統問題未出現「睇廣告賺5積分!」的按鈕，中移香港並不對此承擔任何責任。 點擊按鈕即視為同意觀看來自Google的時長為10秒至120秒的視頻廣告, 但非完成積分簽到後就會必然出現視頻廣告, MyLink無法干預由Google分配的視頻廣告來源或頻次。當有Google的視頻廣告出現, 合資格參加者於獎賞日曆內完成該完整視頻廣告觀賞後, 即待廣告上的「指定秒數後可獲獎勵」按鈕中的倒計時結束而且出現「已發放獎勵」並關閉廣告後, 獎賞日曆主頁出現「成功獲得額外5積分」則可成功獲得5積分獎勵, 每位合資格參加者於一個曆日內最多可獲得該5積分一次。上述兩個按鈕的語言視乎合資格參加者使用中的設備之語言設置, 例如合資格參加者的設備語言使用的是英文, 按鈕則會顯示「Reward in 指定秒數 seconds」及「Reward granted」。如在觀看視頻廣告過程中出現任何人為或不可抗力之情況導致無法完成該完整視頻廣告觀賞, 包括但不限於合資格參加者退出MyLink、關機或出現網路異常等, 則無法獲得上述獎勵。合資格參加者不得使用任何技術手段或軟體跳過廣告。如發現合資格參加者作弊行為, MyLink有權取消其獲得的積分獎賞, 而不做另行通知。觀賞廣告獲額外5積分為獨立積分獲取活動並不受第（a）I-VI的規則限制。',
      'VIII.廣告由第三方供應商Google提供, MyLink對Google提供的廣告之內容的真實性、合法性及完整性均不負責, 對Google的商譽與可信度均無控制力及保證。如對廣告有任何查詢、申索或投訴, 合資格參加者應直接向有關供應商提出。MyLink對此不承擔任何責任。',
      'IX.合資格參加者參加活動、觀賞視頻廣告及/或獲得額外積分純屬自願性質及需自行承擔參加活動、觀賞視頻廣告及/或額外積分之任何風險及全部責任。有關MyLink之連結及第三方廣告服務之相關條款及細則, 請參閱【關於MyLink】 > 【服務及條款】 中的第12段。',
      '(b)「卡券領取」活動：',
      'I.活動將會不定時發放不同種類、不同數量及限量的商戶電子券（「電子券」）。',
      'II.合資格參加者可透過在MyLink任務樂園頁面點擊「卡券領取」按鈕領取當日可獲取並仍有領取餘額的電子券。',
      'III.電子券不定時發放，每次發放的數量有限，先到先得，領完即止。',
      'IV.活動的「卡券領取」並非每天都有，合資格參與者可點擊MyLink任務樂園頁面內的活動日曆查看當天及/或當月可領取的電子券詳情、總共發放的數量、每位用戶最多可獲取的數量以及「卡券領取」具體的發放日期和時間。電子券種類及數量或會不時變動，發放的電子券詳情以發放電子券當天實際頁面顯示為準。',
      'V.合資格參加者每日最多可點擊領取當日派發的電子券一次，不得重複領取。',
      'VI.即日起至2026年6月30日期間，合資格參加者每天於獎賞日曆完成卡券領取後，出現最多一次「睇廣告獲$5優惠券!」的按鈕, 若因系統問題未出現「睇廣告獲$5優惠券!」的按鈕，中移香港並不對此承擔任何責任。「$」該符號在本條款與細則中意指港元。點擊按鈕即視為同意觀看來自Google的時長為10秒至120秒的視頻廣告, 但非完成卡券領取後就會必然出現視頻廣告, MyLink無法干預由Google分配的視頻廣告來源或頻次。當有Google的視頻廣告出現, 合資格參加者於獎賞日曆內完成該完整視頻廣告觀賞後, 即待視頻廣告上的「指定秒數後可獲獎勵」按鈕中的倒計時結束而且出現「已發放獎勵」並關閉視頻廣告後, 獎賞日曆主頁出現「成功獲得額外卡券」則可成功獲得1張指定「$5優惠券」獎勵, 例如電子券滿$120減$5優惠券（若卡券庫存不足將在14個工作日內補發）, 每位合資格參加者於一個曆日內最多可獲得該優惠券1張。上述兩個按鈕的語言視乎合資格參加者使用中的設備之語言設置, 例如合資格參加者的設備語言使用的是英文, 按鈕則會顯示「Reward in 指定秒數 seconds」及「Reward granted」。如在觀看視頻廣告過程中出現任何人為或不可抗力之情況導致無法完成該完整視頻廣告觀賞, 包括但不限於合資格參加者退出MyLink、關機或出現網路異常等, 則無法獲得上述獎勵。合資格參加者不得使用任何技術手段或軟體跳過廣告。如發現合資格參加者作弊行為, MyLink有權取消其獲得的卡券獎賞, 而不做另行通知。觀賞廣告可獲1張【$5優惠券】為獨立電子券獲取活動並不受第（b）I-VI的規則限制。',
      'VII.廣告由第三方供應商Google提供, MyLink對Google提供的廣告之內容的真實性, 合法性及完整性均不負責, 對Google的商譽與可信度均無控制力及保證。如對廣告有任何查詢、申索或投訴, 合資格參加者應直接向有關供應商提出。MyLink對此不承擔任何責任。',
      'VIII.合資格參加者參加活動、觀賞視頻廣告及/或獲得優惠卡券純屬自願性質及需自行承擔參加活動、觀賞視頻廣告及/或優惠卡券之任何風險及全部責任。有關MyLink之連結及第三方廣告服務之相關條款及細則, 請參閱【關於MyLink】 > 【服務及條款】 中的第12段。',
      'IX.指定「$5優惠券」的電子券詳情或會不時變動，發放的電子券詳情以發放電子券當天實際頁面顯示為準。此電子券的使用受相關的使用條款及細則約束, 合資格參加者可於「個人頭像–我的電子券」頁面查閱所獲得的電子券及使用條款及細則。',
      '(c)「任務樂園看廣告獲積分」活動：',
      'I.即日起至2026年6月30日期間，合資格參加者每個曆日在MyLink任務樂園頁面點擊「睇廣告賺5積分」的按鈕。若因系統問題未出現「睇廣告賺5積分」的按鈕，中移香港並不對此承擔任何責任。點擊按鈕即視為同意觀看來自Google的時長為10秒至120秒的視頻廣告, 但非必然出現廣告, MyLink無法干預由Google分配的廣告來源或頻次。當有Google的視頻廣告出現, 合資格參加者於任務樂園內完成該完整視頻廣告觀賞後, 即待廣告上的「指定秒數後可獲獎勵」按鈕中的倒計時結束而且出現「已發放獎勵」並關閉廣告後, 任務樂園主頁出現「成功獲得5積分」則可成功獲得5積分獎勵。每位合資格參加者於一個曆日內透過「任務樂園看廣告獲積分」活動最多可獲得該5積分兩次。上述兩個按鈕的語言視乎合資格參加者使用中的設備之語言設置, 例如合資格參加者的設備語言使用的是英文, 按鈕則會顯示「Reward in 指定秒數 seconds」及「Reward granted」。如在觀看視頻廣告過程中出現任何人為或不可抗力之情況導致無法完成該完整視頻廣告觀賞, 包括但不限於合資格參加者退出MyLink、關機或出現網路異常等, 則無法獲得上述獎勵。合資格參加者不得使用任何技術手段或軟體跳過廣告。如發現合資格參加者作弊行為, MyLink有權取消其獲得的積分獎賞, 而不做另行通知。「任務樂園看廣告獲積分」活動為獨立積分獲取活動並不受「積分簽到」活動中觀看廣告賺取積分的規則限制。',
      'II.廣告由第三方供應商Google提供, MyLink對Google提供的廣告之內容的真實性, 合法性及完整性均不負責, 對Google的商譽與可信度均無控制力及保證。如對廣告有任何查詢、申索或投訴, 合資格參加者應直接向有關供應商提出。MyLink對此不承擔任何責任。',
      'III.合資格參加者參加活動、觀賞視頻廣告及/或獲得積分獎勵純屬自願性質及需自行承擔參加活動、觀賞視頻廣告及/或額外積分之任何風險及全部責任。有關MyLink之連結及第三方廣告服務之相關條款及細則, 請參閱【關於MyLink】 > 【服務及條款】 中的第12段。合資格參加者可點擊任務樂園頁面內的「積分明細」查看已領取的積分。',
      '(d)合資格參加者只可於每天00:00至23:59簽到領取當天的電子券/MyLink 積分，不可補簽/補領或提前簽到/領取。',
      '5.每個終端設備（如手機、平板電腦）只限一位元合資格參加者使用同5個香港流動電話號碼登記的MyLink帳號參加活動，如合資格參加者以同一個終端設備登入多於5個以上的MyLink帳號參加活動，中移香港有權取消相關MyLink帳號參加活動以及獲得MyLink積分的資格。'
    ],
    c7: 'MyLink積分使用及注意事項',
    c8: [
      '6.活動期內，合資格參加者如獲得MyLink積分，所獲得的MyLink積分會在3個工作天內自動存入其MyLink帳戶。MyLink積分餘額顯示在「個人頭像–我的積分」頁面。',
      '7.活動所獲得的MyLink積分有效期取決於積分被存入用戶的 MyLink 帳戶之時間（「積分有效期」）。',
      '8.如活動領取的MyLink積分與任何其他積分領取活動的條款細則存有差異，一律以MyLink帳戶中所顯示的有效MyLink積分為準。',
      '9.合資格參加者應於積分有效期滿前使用MyLink積分作兌換獎賞或購買指定產品/服務，逾期作廢，並將不獲補發或延長有效期。合資格參加者兌換及使用積分，須閱讀並同意MyLink積分計畫的條款及細則（https://mylink.komect.com/mylink/#/integral/rules?lang=tc）。',
      '10.中移香港保留全部的酌情權及決定權處理用戶的MyLink積分。在下列情況下， MyLink 可暫停發放MyLink積分或隨時從任何用戶的 MyLink 帳戶中扣除MyLink積分而不作另行通知 (包括但不限於)：（a）在使用者欺詐或涉嫌欺詐的情況下；（b）用戶以不公平的手段（包括但不限於不誠實使用、欺騙、錯用或濫用）而獲得MyLink積分；（c）用戶取消、撤銷任何符合領取MyLink積分的合資格服務或流動電話號碼服務；（d）中移香港或任何服務提供者錯誤計算使用者應獲取的MyLink積分；及／或（e）任何中移香港合理地確保使用者正當地積分的情況下。'
    ],
    c9: '電子券使用及注意事項',
    c10: [
      '11.活動內，合資格參加者如獲得電子券，所獲得的電子券會在3個工作天內自動存入其MyLink帳戶。合資格參加者可於「個人頭像–我的電子券」頁面查閱所獲得的電子券。',
      '12.合資格參加者兌換及使用電子券即表示知悉並同意該電子券的條款及細則，電子券的條款及細則可在「我的電子券」頁面查閱。',
      '13.合資格參加者獲取電子券後，不可退換或兌換現金，亦不能更換丶退款丶轉贈或轉讓他人，不同合資格參加者的電子券亦不可合併使用。當合資格參加者撤銷其MyLink註冊帳戶時，其MyLink帳戶內的電子券將會自動登出及不獲補發，中移香港亦不會作出任何補償。',
      '14.所有電子券均有使用有效期（「電子券有效期」），以「我的電子券」頁面上顯示為準。所有電子券在電子券有效期過後均屬無效，任何逾期或未使用之電子券將不能退款、補發或更改為其他產品或服務。',
      '15.中移香港保留全部的酌情權及決定權處理使用者的電子券。在下列情況下， MyLink 可暫停發放電子券或隨時從任何用戶的 MyLink 帳戶中扣除電子券而不作另行通知 (包括但不限於)：（a）在使用者欺詐或涉嫌欺詐的情況下； （b）用戶以不公平的手段（包括但不限於不誠實使用、欺騙、錯用或濫用）而獲得電子券；（c）使用者取消、撤銷任何符合領取電子券的合資格服務或流動電話號碼服務；（d）中移香港或任何服務提供者錯誤計算使用者應獲取的電子券；及／或（e）任何中移香港合理地確保使用者正當地使用電子券的情況下。'
    ],
    c11: '個人資料注意事項',
    c12: [
      '16.合資格參加者同意中移香港之一般個人資料收集聲明及私隱政策聲明所載之內容，並接受其約束。上述聲明分別載於 https://www.hk.chinamobile.com/tc/pics.html及 https://www.hk.chinamobile.com/tc/privacy.html。',
      '17.合資格參加者可能會被要求向中移香港提供個人識別資料。為讓參加者可以參加活動，該些資料是必要的。倘若參加者未能提供所需資料，參加者將不能獲得活動參加/獲得MyLink積分/電子券的資格',
      '18.合資格參加者有權根據《個人資料（私隱）條例》(第 486 章)的規定，要求查閱或更正參加者之個人資料。如有任何查閱或更正資料的要求，詳情請參閱中移香港的私隱政策聲明。',
      '19.合資格參加者如欲查閱個人資料及更正個人資料或詢問個人資料有關聲明，請致函：中國移動香港有限公司，地址：香港新界葵涌葵昌路 51 號九龍貿易中心1座20樓，收信人：資料保護主任；或致電中國移動香港拒收商業電子訊息登記熱線 6226 4926 或客戶服務熱線 12580。'
    ],
    c13: '其他注意事項',
    c14: [
      '20.如發現合資格參加者以外掛程式或其他非正式途徑，如空號或假帳戶或其他影響公平性的方式參加活動，中移香港將取消該參加者的參加活動及/或獲得MyLink積分/電子券的資格而不作另行通知。',
      '21.如合資格參加者因任何中移香港未能控制之因素以致所遞交之個人資料有錯漏、不實或不正確，或導致中移香港未能聯絡或核實合資格參加者身份，即視為放棄參加活動及/或獲得MyLink積分/電子券資格。合資格參加者不得要求補發或任何形式的補償，中移香港亦毋須為此承擔任何責任。',
      '22.如中移香港懷疑任何合資格參加者有（i）進行或與異常/可疑活動有關；或（ii）使用不當的方法或欺詐行為而使活動之任何部份運作中斷或受到干擾，或導致技術問題；或發現（iii）任何不誠實的行為、提供虛假、錯誤或不正確的資料；或（iv）任何違反本條款及細則或其他任何適用法律或法例條文或任何監管規定；或（v）用戶有任何非善意或惡意使用任何相關服務之情況；中移香港擁有酌情權及最終決定權在不作任何通知及毋須對任何人士負上任何責任的情況下，自行決定暫停、取消其參加活動及/或獲得積分/電子券的資格及日後推廣活動的資格，並對該用戶保留追究權利。',
      '23.合資格參加者獲取積分後，不可退換或兌換現金，亦不能更換丶退款丶轉贈或轉讓他人，不同合資格參加者的積分亦不可合併使用。當合資格參加者撤銷其MyLink註冊帳戶時，其MyLink帳戶內的積分將會自動註銷及不獲補發，中移香港亦不會作出任何補償。',
      '24.如任何人士曾經在中移香港的MyLink及網上商店的活動、或任何使用MyLink及網上商店的過程中作出不誠實及欺詐行為、或任何非善意或非正常之使用、或曾經違反中移香港任何活動之條款及細則之行為，將自動被列入活動黑名單，喪失參與活動及獲得MyLink積分/電子券的資格。',
      '25.所有是次活動所獲贈、購買和兌換的電子券、商品或服務受相關條款及細則約束。活動所有的電子券、商品或服務視乎供應情況而定，換領或售完即止。',
      '26.電子券由相關供應商（「供應商」）提供，中移香港對任何第三方供應商所提供的電子券或相關商品、服務之品質、安全性及合法性，供應商的商譽與可信性均無控制力及保證。如對以上電子券、商品或服務的質素或供應情況有任何查詢、申索或投訴，客戶應直接向有關供應商提出。中移香港對此不承擔任何責任。',
      '27.在法律容許之最大限度，中移香港不會對第三方供應之電子券、商品或服務的任何功能或內容、及使用優惠可能或實質所造成或引致的任何後果、費用、支出、損失或損害負上任何責任。',
      '28.中移香港並不會對電子券、商品或服務之任何相關資料、內容及其功能，包括但不限於特定目的之適用性、可用性、品質、性質、準確性和實用性、或當中可能包含之知識產權之正當性作出任何陳述、保證或承擔任何責任。',
      '29.如因電力或網路故障、或其他中移香港不能控制的情況下任何服務失效、中斷、延誤或暫時中止所引致之損失及損害（不論直接或間接），例如因任何技術故障、困難或錯誤、網路故障、中斷或擠塞、手機程式故障、任何第三方引致之原因、軟體的不相容性問題或其他任何原因（包括但不限於任何終端設備或互聯網網路問題）而產生或引致任何遲延、遺失、錯誤或無法辨識的響應等情況、或未能參加活動或獲得積分/電子券，中移香港概不負責及不會作出任何補發或補償。',
      '30.參加者參加活動及/或領取積分/電子券純屬自願性質及需自行承擔參加活動及/或領取積分/電子券之任何風險及全部責任。任何合資格參加者因參加活動及/或領取積分/電子券而引致之任何損失、傷害、費用、索賠、訴訟（包括但不限於直接、間接及後果性損失），中移香港概不負上任何法律責任或作出賠償。',
      '31.凡由於中移香港無法合理控制或並非其過失或疏忽所致的原因，包括但不限於電力故障、戰爭、面臨戰爭威脅、騷亂或其他公民抗命行為、暴動、天災、由政府或任何其他國家法律機關所實施的限制或任何其他工業或行業糾紛、火災、爆炸、風暴、水災、雷電、地震或其他自然災害，以致延遲或未能履行本條款及細則的全部或部分條款而造成任何損失或損害，中移香港均無須負責。',
      '32.本條款及細則及一切與本條款及細則相關的事項均應受香港法律專屬管轄及以其作解釋及執行。參加者同意，如有任何分歧、爭議、請求、訴訟或索賠等，將不可撤回及無條件地服從香港法院的專屬管轄權。',
      '33.中移香港保留隨時更改或終止活動及修訂本條款及細則及相關條款及細則的權利而毋須事先通知。',
      '34.如任何參加者有任何違反法律、本條款及細則或可能損害第三方權利的行為或不作為，該參加者同意並契諾向中移香港為其行為或不作為引致或相關的任何糾紛及索賠作出全面彌償以及使中移香港免受損害。',
      '35.本條款及細則中的每一條條款應有獨立的執行力，其有效性不受其他條款之無效性影響。',
      '36.除合資格參加者和中移香港外，任何人均不享有香港法例《合約(第三者權利)條例》(第623章)下的任何權利，以執行或享有本條款及細則任何條文的利益或權利。',
      '37.活動不設上訴機制。如有任何爭議，中移香港保留最終決定權。任何爭議將以中移香港之系統記錄作為確據。',
      '38.本條款及細則的中、英文版如有任何歧義，概以中文版為準。'
    ]
  },
  d84: '是日無卡券',
  d85: '點我睇下有咩優惠',
  d86: '多謝參與',
  d87: '忌',
  d88: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox12/titleBg_tc.webp',
  d89: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox2025/google_points_tc.webp',
  d90: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox2025/google_coupon_tc.webp',
  d91: '成功獲得額外積分',
  d92: '成功獲得額外卡券',
  d93: '網絡異常',
  d94: '卡券發放失敗',
  d95: '請待14個工作天內補發',
  d96: '你的⼿機或設備可獲得此積分獎賞的數量已超出限制',
  d97: '您的手機/設備系統暫不支持Google廣告展示',
  d98: '"您的手機/設備系統暫不支持此Google廣告展示, 請更新系統至最新版本"',
  d99: '展開',
  d100: '收起',
  d101: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox2025/points_banner_tc.webp',
  d101_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/googleBanner/points_banner_tc_new.webp',
  d102: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox2025/coupon_banner_tc.webp',
  d102_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/googleBanner/coupon_banner_tc_new.webp',
  d103:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox12/titleBgBlue_tc.webp',
  e1: '之前已領過這張卡券, 領取次數已達上限',
  e2: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/banner_tc.png',
  e2_1: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/vip_contract/banner_tc.png',
  e3: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/points_tc%402x.png',
  e3_1: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/vip_contract/points_tc.png',
  e4: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/tag_tc%402x.png',
  e4_1: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/vip_contract/tag_tc.png',
  e5: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/coupon_tc%402x.png',
  e6: '前往辦理',
  e7: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/coupon1_tc.png',
  e7_1: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/vip_contract/coupon1_tc.png',
  e8:'開通後，額外領',
  e9:'+90積分/月',
  e10:'會員專享券',
  e11:'每月仲有',
  e11_1:'$1000+',
  e11_2:'慳錢著數等你拎!',
  e12:'暫不開通',
  e13:'立即開通',
  e14:'每月簽到',
  e15:'積分,',
  e16:'仲有',
  e17:'慳錢著數！',
  e18:'開通Link著數會員',
  g1:'暫無Google廣告來源，請稍後再來~',
  g2:'您當前的設備不支持Google廣告播放',
  g3:'您當前設備或MyLink App版本過低，不支持Google廣告播放',
  g4:'拎額外卡券',
  g5:'拎額外積分',
  g6:'注意！仲有積分未拎哦！',
  g7:'注意！仲有卡券未拎哦！',
  g8:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/btnMoreTicket_tc.png',
  g9:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/btnMorePoints_tc.png',
  removeDialogImg:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox12/removeDialog_tc.webp',
  removeDialogText:'知道了',
}
